import React from 'react';
export function Footer() {
  return <footer className="bg-brand-graphite px-4 py-6 text-center text-[11px] text-white/60" data-id="element-70" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-2xl space-y-2.5" data-id="element-71" data-mp="3ggtzeln15p6t">
        <p className="font-bold text-white/80" data-id="element-72" data-mp="32o48q3wk3w3d">
          © 2026 ENGLISH TEACHER PRO™ — Tutti i Diritti Riservati.
        </p>
        <p className="leading-snug" data-id="element-73" data-mp="36qhg0wqyc229">
          ENGLISH TEACHER PRO™ è una risorsa didattica di supporto per insegnanti
          di inglese. Non rappresenta un curriculum ufficiale, una certificazione
          linguistica o un programma approvato da un ente educativo specifico.
          L’insegnante rimane responsabile della selezione e dell’adattamento del
          materiale in funzione del livello, dell’età, degli obiettivi e delle
          necessità dei propri studenti.
        </p>
        <p data-id="element-74" data-mp="29y5i442prqwl">
          <a href="mailto:kitonline27@gmail.com" className="font-bold text-white/80 transition-colors duration-150 ease-out hover:text-white" data-id="element-75" data-mp="29ydwk0ehj49w">
            kitonline27@gmail.com
          </a>
        </p>
        <nav className="flex flex-wrap justify-center gap-x-2 gap-y-1 font-bold uppercase tracking-wide" data-id="element-76" data-mp="3lbddkvg7mdmv">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-77" data-mp="3v7q5pow3wjfi">
            Termini e Condizioni
          </a>
          <span aria-hidden="true" data-id="element-78" data-mp="3q7bww4mol5gf">•</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-79" data-mp="82ienymgqkhh">
            Privacy Policy
          </a>
          <span aria-hidden="true" data-id="element-80" data-mp="31umvaqetzm7">•</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-81" data-mp="ht39rc2xh6vn">
            Contatti
          </a>
        </nav>
      </div>
    </footer>;
}